import {Injectable} from '@angular/core';
import {Http, Request, Response, RequestOptionsArgs, RequestOptions, Headers} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/share';
import 'rxjs/add/observable/throw';
import {HttpClient} from '../../../../utilities/services/http-client/http-client.service';
import {AuthService} from '../auth.service';
import {AppRequestOptionArgs} from '../../../../utilities/services/http-client/AppRequestOptionArgs';
import {AppRequestOptions} from '../../../../utilities/services/http-client/AppRequestOptions';

/**
 * AuthHttp Class
 *
 * Extends the HttpClient to allow us to handle token refresh error's
 * when a user is authenticated
 */
@Injectable()
export class AuthHttp extends HttpClient {

  constructor(http: Http, private auth: AuthService) {
    super(http);
  }

  /**
   * Performs any type of http-client request
   * @param url
   * @param options
   * @returns {Observable<Response>}
   */
  request(url: string | Request, options?: AppRequestOptionArgs): Observable<Response> {
    return super
      .request(url, this.getRequestOptionArgs(options))
      .catch((error: Response) => this.catchAuthFailure(error));
  }

  /**
   * Performs a request with `get` http-client method.
   * @param url
   * @param options
   * @returns {Observable<Response>}
   */
  public get(url: string, options?: AppRequestOptionArgs): Observable<Response> {
    return super
      .get(url, this.getRequestOptionArgs(options))
      .catch((error: Response) => this.catchAuthFailure(error));
  }

  /**
   * Performs a request with `post` http-client method.
   * @param url
   * @param body
   * @param options
   * @returns {Observable<Response>}
   */
  public post(url: string, body: any, options?: AppRequestOptionArgs): Observable<Response> {
    return super
      .post(url, body, this.getRequestOptionArgs(options))
      .catch((error: Response) => this.catchAuthFailure(error));
  }

  /**
   * Performs a request with `put` http-client method.
   * @param url
   * @param body
   * @param options
   * @returns {Observable<Response>}
   */
  public put(url: string, body: any, options?: AppRequestOptionArgs): Observable<Response> {
    return super
      .put(url, body, this.getRequestOptionArgs(options))
      .catch((error: Response) => this.catchAuthFailure(error));
  }

  /**
   * Performs a request with `delete` http-client method.
   * @param url
   * @param options
   * @returns {Observable<Response>}
   */
  public delete(url: string, options?: AppRequestOptionArgs): Observable<Response> {
    return super
      .delete(url, this.getRequestOptionArgs(options))
      .catch((error: Response) => this.catchAuthFailure(error));
  }

  /**
   * Get the token bearer string
   * @returns {string}
   */
  public getTokenBearer() {
    return 'Bearer ' + localStorage.getItem('access_token');
  }

  /**
   * @param error
   * @returns {any}
   */
  protected catchAuthFailure(error: Response) {
    if (this.isInvalidToken(error))
      this.auth.logout();
    return Observable.throw(error);
  }
  /**
   * Checks the response to see if it is an invalid token response.
   * @param error The error response
   * @returns {boolean}auth
   */
  private isInvalidToken(error: Response) {
    console.log(error);
    return error.status === 401;
  }
  /**
   * Adds in the auth token to the header
   * @param options
   * @returns {RequestOptionsArgs}
   */
  private getRequestOptionArgs(options?: AppRequestOptionArgs): AppRequestOptionArgs {
    if (options == null)
      options = new AppRequestOptions();
    if (options.headers == null)
      options.headers = new Headers();
    options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('access_token'));
    return options;
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/user/services/auth/http/auth-http.service.ts